import { useEffect } from "react";
import useTrackGoogleEvent, {
  CUSTOMER_IS_A_PROFESSIONAL,
  POPULATE_BOARD_EVENT,
} from "../../../observability/googleTagManager";
import { USD } from "../../../../constants/orders";
import { useAppSelector } from "../../store";
import {
  trackBoardFailed,
  trackCustomerSawBoardFailed,
} from "../../../observability/boardTracking";
import useUserIsActive from "../../isActive";
import useShipmentsFromContext from "./shipments";

const COMMON_EMAIL_PROVIDER_DOMAINS = new Set([
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "yahoo.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "proton.me",
  "protonmail.com",
]);

function userIsProfessional(email: string | null) {
  if (email === null) {
    return false;
  }
  const emailDomain = email.split("@").pop();
  if (emailDomain === undefined) {
    return false;
  } else if (emailDomain.endsWith(".edu")) {
    return false;
  } else if (COMMON_EMAIL_PROVIDER_DOMAINS.has(emailDomain)) {
    return false;
  } else if (emailDomain == "flashpcb.com") {
    return false;
  }
  return true;
}

export default function useTrackBoard(boardId: string) {
  const trackGoogleEvent = useTrackGoogleEvent();
  const board = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.board || null,
  );
  const shipments = useShipmentsFromContext(boardId);
  const errored = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.errored || false,
  );
  const userId = useAppSelector((state) => state.auth.userId);
  const email = useAppSelector((state) => state.auth.email);
  const userIsActive = useUserIsActive();

  useEffect(() => {
    if (board !== null && shipments !== null) {
      trackGoogleEvent({
        action: POPULATE_BOARD_EVENT,
        parameters: {
          value: shipments[0]!.requires_stencil ? 40 : 10,
          currencyCode: USD,
          boardId: board.id,
        },
      });
    }
  }, [board, shipments, trackGoogleEvent]);

  useEffect(() => {
    if (
      board !== null &&
      board.user_id === userId &&
      userIsProfessional(email)
    ) {
      trackGoogleEvent({
        action: CUSTOMER_IS_A_PROFESSIONAL,
        parameters: {
          boardId: board.id,
        },
      });
    }
  }, [board, email, trackGoogleEvent, userId]);

  useEffect(() => {
    if (errored && userIsActive && board !== null) {
      trackCustomerSawBoardFailed(board.id, board.cad_source);
    }
  }, [board, errored, userIsActive]);
}

export function useTrackBoardFailed(boardId: string) {
  const errored = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.errored || false,
  );

  useEffect(() => {
    if (errored) {
      trackBoardFailed(boardId);
    }
  }, [boardId, errored]);
}
